import React, { FunctionComponent, PropsWithChildren } from 'react';

import {
  default as MuiFormControl,
  FormControlProps,
} from '@mui/material/FormControl';

const FormControl: FunctionComponent<FormControlProps> = (
  props: PropsWithChildren<FormControlProps>
) => {
  return <MuiFormControl {...props}>{props.children}</MuiFormControl>;
};

export default FormControl;
